import axios from 'axios';

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
export const API = `${BACKEND_URL}/api`;

export const api = axios.create({
  baseURL: API,
  withCredentials: true,
});

let onUnauthorized = null;
export const setUnauthorizedHandler = (fn) => { onUnauthorized = fn; };

api.interceptors.response.use(
  (r) => r,
  (err) => {
    const url = err?.config?.url || '';
    if (err?.response?.status === 401 && onUnauthorized && !url.includes('/auth/')) {
      onUnauthorized();
    }
    return Promise.reject(err);
  }
);
